<template lang="pug">
  button.b-button._icon._fa(
    type="button"
    @click.stop="deleteNodes({id})"
  )
    font-awesome-icon(
      icon="trash-alt"
      fixed-width
    )
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'NodeDeleteButton',
  props: {
    id: String,
  },
  methods: {
    ...mapActions('nodes', [
      'deleteNodes',
    ]),
  },
};
</script>
